export default {"src":"/_next/static/media/8.fb517ebf.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};